import React from 'react';
import type { ContatoFiscalCliente } from '@pieltec/contracts';

const inputClass = 'w-full min-h-11 rounded-md border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-slate-900 focus:outline-none focus:ring-2 focus:ring-slate-900/10';

/** Campos comuns à criação e à edição: mesma semântica e limites nos dois fluxos. */
export function CamposContatoCliente({ contato, onChange }: {
  readonly contato: ContatoFiscalCliente;
  readonly onChange: (campo: keyof ContatoFiscalCliente, valor: string) => void;
}): React.ReactElement {
  const campos = [
    ['contato', 'Nome do contato', 'campo-contato', 'text', 200],
    ['email', 'E-mail', 'campo-email', 'email', 200],
    ['telefone1Ddd', 'DDD principal', 'campo-tel1-ddd', 'tel', 2],
    ['telefone1Numero', 'Telefone principal', 'campo-tel1-numero', 'tel', 20],
    ['telefone2Ddd', 'DDD secundário', 'campo-tel2-ddd', 'tel', 2],
    ['telefone2Numero', 'Telefone secundário', 'campo-tel2-numero', 'tel', 20],
  ] as const;
  return <fieldset className="grid grid-cols-1 gap-4 md:grid-cols-2">
    <legend className="mb-3 text-sm font-semibold text-slate-700">Contato principal</legend>
    {campos.map(([campo, label, id, tipo, limite]) => <div key={campo}>
      <label htmlFor={id} className="mb-1 block text-xs font-semibold text-slate-700">{label}</label>
      <input id={id} className={inputClass} type={tipo} maxLength={limite} value={contato[campo] ?? ''}
        onChange={(event) => onChange(campo, event.target.value)} />
    </div>)}
  </fieldset>;
}
